import React from "react";
import {LuInfo, LuX} from "react-icons/lu";
import {Dialog, Heading, Modal} from "react-aria-components";
import Notification from "../../../components/Notification/Notification.js";

export function RolesWithAccessInfoButton() {
    let [showModal, setShowModal] = React.useState(false);

    function toggleModal() {
        setShowModal(!showModal);
    }

    return <div className="hosting-info-button">
        <LuInfo onClick={toggleModal}/>
        <Modal isOpen={showModal} isDismissable onOpenChange={toggleModal}>
            <Dialog aria-label="Hosting Mode Info" className="hosting-info-modal">
                <Heading className="title">Roles with Access</Heading>
                <p>
                    This setting allows you to control which roles have access to the
                    database. You can select one or more roles from the list to grant them access.
                    <Notification>
                        If no roles are selected,<br/>the database will be inaccessible.
                    </Notification>
                </p>
                <div className="close"><LuX onClick={toggleModal}/></div>
            </Dialog>
        </Modal>
    </div>
}